import type { FaireProductEntity } from "../../entity_types/product";

export const p_7cnjyd769a: FaireProductEntity = {
  token: "p_7cnjyd769a",
  type: "product",
  name: "HAKONE",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/6d980d5591668dbc4853970622a8cd4fe6c7d2325fa48f686e0c2be9b4d37eda.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6de7b1b93291c4375048f8571f91f32f4b11481b58196657fc2feb9fcf2ee0fc.jpeg",
    "https://cdn.faire.com/fastly/ab51a93447e3019895cc39af84d980c06e022101b63d451eef09cb0315e6d66c.jpeg",
    "https://cdn.faire.com/fastly/e2b0b62f10eecdaa15755f2d249ee8d3cf4882dc899b2734fcaa89fa5f771022.jpeg",
    "https://cdn.faire.com/fastly/0ba1397b034840d4aa62232858ebd000527c4d9d0434a7931754561f19c4f810.jpeg",
    "https://cdn.faire.com/fastly/919d33400aaf5a3fcdd7d263a712ae010dc662cbae7979a8291d4444e9cd8c17.jpeg",
  ],
  priceDollars: 24,
  description:
    "Breathe in the tranquil air of Hakone’s steaming onsens, where mountains cradle hidden springs and mist drifts over volcanic valleys. Inspired by the art of forest bathing, this scent blends earthy stone and volcanic ash with crisp cypress, moss-cooled air, and the subtle freshness of crushed tea leaves.\n\nJapanese cypress, sacred stone, onsen water, crushed tea, volcanic ash\n\nWe collaborated on this collection with the incredibly talented Tokyo-based artist Keisuke Shoda, founder of Studio The Blue Boy. Known for his playful aesthetic that blends traditional Japanese style with a modern, whimsical twist, his artwork beautifully captures the essence of some of our favorite parts of Japan.\n\nThese beautiful hand-painted ceramics are designed to be re-loved and reused.\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n8 ounces (226g), comes in our signature Japan Collection box.\n",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T13:49:22.287Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
